import React from "react";

import { MenuItem, TextField, TextFieldProps } from "@mui/material";
import clsx from "clsx";
import { range } from "lodash";
import { makeStyles } from "tss-react/mui";

import { isSameDate } from "@/utils/datetime";

type Props = TextFieldProps & {
  disablePast?: boolean;
  sendsOn?: Date;
};

const useStyles = makeStyles()({
  root: {
    "& .MuiInput-root": {
      color: "#1FD4AF",
    },
    "& .MuiInput-underline:before": {
      border: "0 !important",
      content: '""',
    },
    "& .MuiSelect-icon": {
      color: "#1FD4AF",
    },
  },
});

const MINUTES = range(0, 1440, 15);

function hour(minutes: number) {
  const hour12 = Math.floor(minutes / 60) % 12;
  return hour12 === 0 ? 12 : hour12;
}

function minute(minutes: number) {
  return (minutes % 60).toString().padStart(2, "0");
}

function period(minutes: number) {
  return minutes < 720 ? "am" : "pm";
}

const TimePicker: React.FC<Props> = ({
  disablePast = false,
  sendsOn = new Date(),
  ...props
}) => {
  const { classes } = useStyles();

  function disableTime(minute: number) {
    const now = new Date();
    const nowInMinutes = now.getHours() * 60 + now.getMinutes();

    return disablePast && isSameDate(sendsOn, now) && minute < nowInMinutes;
  }

  return (
    <TextField
      {...props}
      className={clsx(classes.root, props.className)}
      variant="standard"
      InputProps={{
        disableUnderline: true,
      }}
      select
    >
      {MINUTES.map((min) => (
        <MenuItem key={min} value={min} disabled={disableTime(min)}>
          {hour(min)}:{minute(min)} {period(min)}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default TimePicker;
